import { useContext, useEffect } from "react";

import { Container, FormControlLabel, Grid, Switch } from "@material-ui/core";

import HeaderModule from "../../../components/header/HeaderModule.js";
import { GridStyled } from "../../../theme/styles/Layout";
import {
  ReguaCobrancaContext,
  ReguaCobrancaContextProvider,
} from "./contexts/ReguaCobrancaContext";
import Card from "../../../components/cards/Card.js";
import TextFieldErp from "../../../components/basics/TextFieldErp.js";
import useReguaCobrancaController from "./controllers/ReguaCobrancaController.js";
import Btn from "../../../components/buttons/Btn.js";
import Loading from "../../../components/basics/Loading.js";
import { getReguaCobrancaByEmpresaId } from "../../../repositories/qerpapi/erp/faturamento/ReguaCobrancaRepository.js";
import { QueryParamsContext } from "../../../context/QueryParamsContext.js";

const View = () => {
  const {
    checkBeforeExpiration,
    setCheckBeforeExpiration,
    checkOnExpiration,
    setCheckOnExpiration,
    checkPendency,
    setCheckPendency,
    checkWarningSuspension,
    setCheckWarningSuspension,
    checkSuspension,
    setCheckSuspension,
    checkToThank,
    setCheckToThank,

    daysBeforeExpiration,
    setDaysBeforeExpiration,
    daysPendency,
    setDaysPendency,
    daysWarningSuspension,
    setDaysWarningSuspension,
    daysSuspension,
    setDaysSuspension,

    errors,
    loading,
    setLoading,
  } = useContext(ReguaCobrancaContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { handleSubmit } = useReguaCobrancaController();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const response = await getReguaCobrancaByEmpresaId({
          empresa_id: queryParams.empresa_id,
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        if (!response?.data?.[0]) return;

        const data = response?.data?.[0];

        setCheckBeforeExpiration(!!data.aviso_pre_vencimento_dias);
        setCheckOnExpiration(!!data.aviso_vencimento_flag);
        setCheckPendency(!!data.aviso_pendencia_dias);
        setCheckWarningSuspension(!!data.aviso_suspensao_dias);
        setCheckSuspension(!!data.suspensao_dias);
        setCheckToThank(!!data.agradecimento_pagamento_flag);

        setDaysBeforeExpiration(data.aviso_pre_vencimento_dias || "0");
        setDaysPendency(data.aviso_pendencia_dias || "0");
        setDaysWarningSuspension(data.aviso_suspensao_dias || "0");
        setDaysSuspension(data.suspensao_dias || "0");
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    queryParams,
    setCheckBeforeExpiration,
    setCheckOnExpiration,
    setCheckPendency,
    setCheckSuspension,
    setCheckToThank,
    setCheckWarningSuspension,
    setDaysBeforeExpiration,
    setDaysPendency,
    setDaysSuspension,
    setDaysWarningSuspension,
    setLoading,
  ]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule title="RÉGUA DE COBRANÇA" />

      <Container maxWidth="lg">
        <GridStyled $margin="80px 0px 0px 0px" container spacing={3}>
          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkBeforeExpiration ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkBeforeExpiration}
                        onChange={() => {
                          setCheckBeforeExpiration((current) => !current);
                          setDaysBeforeExpiration("0");
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Aviso antes do vencimento"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextFieldErp
                    mask="integer"
                    error={errors.daysBeforeExpiration}
                    helperText={errors.daysBeforeExpiration}
                    disabled={!checkBeforeExpiration}
                    label="Dias antes do vencimento"
                    value={daysBeforeExpiration}
                    setValue={setDaysBeforeExpiration}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkOnExpiration ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkOnExpiration}
                        onChange={() =>
                          setCheckOnExpiration((current) => !current)
                        }
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Aviso no vencimento"
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkPendency ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkPendency}
                        onChange={() => {
                          setCheckPendency((current) => !current);
                          setDaysPendency("0");
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Aviso de pendência"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextFieldErp
                    mask="integer"
                    error={errors.daysPendency}
                    helperText={errors.daysPendency}
                    disabled={!checkPendency}
                    label="Dias de atraso"
                    value={daysPendency}
                    setValue={setDaysPendency}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkWarningSuspension ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkWarningSuspension}
                        onChange={() => {
                          setCheckWarningSuspension((current) => !current);
                          setDaysWarningSuspension("0");
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Aviso de suspensão"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextFieldErp
                    mask="integer"
                    error={errors.daysWarningSuspension}
                    helperText={errors.daysWarningSuspension}
                    disabled={!checkWarningSuspension}
                    label="Dias de atraso"
                    value={daysWarningSuspension}
                    setValue={setDaysWarningSuspension}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkSuspension ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkSuspension}
                        onChange={() => {
                          setCheckSuspension((current) => !current);
                          setDaysSuspension("0");
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Suspensão"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextFieldErp
                    mask="integer"
                    error={errors.daysSuspension}
                    helperText={errors.daysSuspension}
                    disabled={!checkSuspension}
                    label="Dias de atraso"
                    value={daysSuspension}
                    setValue={setDaysSuspension}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card
              chipcolor="transparent"
              line="left"
              lineColor={checkToThank ? "blue" : "lightgrey"}
              fullWidth={true}
            >
              <Grid
                item
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={checkToThank}
                        onChange={() => setCheckToThank((current) => !current)}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Agradecimento"
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item container justifyContent="flex-end">
            <Btn label="Salvar" onClick={handleSubmit} />
          </Grid>
        </GridStyled>
      </Container>
    </>
  );
};

const ReguaCobranca = (props) => (
  <ReguaCobrancaContextProvider>
    <View {...props} />
  </ReguaCobrancaContextProvider>
);

export { ReguaCobranca };
